// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._33uI_{line-height:1.2;text-align:center}.g02n4{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background:#e0e8f2;border-radius:50%;height:80px;height:8rem;justify-content:center;margin:0 auto 3rem;width:80px;width:8rem}._1VFIf{fill:#6f7ea2;height:40px;height:4rem;width:40px;width:4rem}.eDuWy{color:#6f7ea2;font-size:16px;font-size:1.6rem;font-weight:800}", ""]);
// Exports
exports.locals = {
	"root": "_33uI_",
	"avatar": "g02n4",
	"avatar__icon": "_1VFIf",
	"info": "eDuWy"
};
module.exports = exports;
